/**
 * Round a timestamp up to the nearest N-minute grid boundary.
 * Used so generated slot starts line up visually with FullCalendar's
 * 15-minute slot grid (avoids "01:03 PM" slot labels).
 */
export const SLOT_GRID_MINUTES = 15;

export function roundUpToGrid(
  tsMs: number,
  gridMinutes: number = SLOT_GRID_MINUTES
): number {
  const stepMs = gridMinutes * 60_000;
  return Math.ceil(tsMs / stepMs) * stepMs;
}
